exports.list = {
    path: '/perusahaan',
    name: 'perusahaan_list', 
      meta: {
        authRequired: true,
      },
    component: () => import("@/views/main/perusahaan/List.vue"),
}
exports.show = {
    path: '/perusahaan/show/:id',
    name: 'perusahaan_show', 
        meta: {
            authRequired: true,
        },
    component: () => import("@/views/main/perusahaan/Show.vue"),
}